import { useMemo } from 'react';
import { Product } from '../../codegen/transactions';
import { useCustomIntl } from '../../i18n/i18n';
import { TRANSACTION_PRODUCT_TO_TRANSLATION_KEY } from '../../i18n/enumMappings';

interface TransactionProductsRepresentationProps {
  products: Product[];
}

export const TransactionProductsRepresentation = ({
  products,
}: TransactionProductsRepresentationProps) => {
  const intl = useCustomIntl();

  const translated_products = useMemo(
    () =>
      products.map((product) =>
        intl.formatMessage({
          id: TRANSACTION_PRODUCT_TO_TRANSLATION_KEY[product],
        }),
      ),
    [products, intl],
  );
  return <div className="ellipsis-1">{translated_products.join(', ')}</div>;
};
